//
// Main
//
// Import this file using the following HTML or equivalent:
// <script src="dist/js/main.min.js" type="text/javascript"></script>
//

jQuery(document).ready(function ($) {

	let $window = $(window);
	let $body = $('body');
    let previous_top = $window.scrollTop();

    $window.on('scroll', function () {

        let top = $window.scrollTop();
        let scroll_direction = (
            top > previous_top
        ) ? 'down' : 'up';

        previous_top = top;

    });

    require('./../../../build/node_modules/@components/mmenu/src/core/js/jquery.mmenu.oncanvas');
    require('./../../../build/node_modules/@components/mmenu/src/addons/js/jquery.mmenu.offcanvas');

    if (typeof $.mmenu === 'function') {

        $('#nav').mmenu();

        let api = $('#nav').data('mmenu');

        api.bind('opened', function () {

            $('a[href="#nav"]').addClass('active');

        });

        api.bind('closed', function () {

            $('a[href="#nav"]').removeClass('active');

        });

    }

    let $photo = $('a[rel^="photo"]');

    if ($window.width() < 750) {

	    $photo.each(function () {
	        if (!$(this).parent().hasClass('video')) {
	            $(this).attr('rel', 'photo-deactivated');

            }

        });

        $body.on('click', 'a[rel="photo-deactivated"]', function (event) {

            event.preventDefault();

        });

    }
	if ($window.width() > 750) {
		$photo.prettyPhoto({
            social_tools: false
        });

    }

    $("a[data-rel*='prettyPhoto']").attr('rel', 'nofollow');

    $('li.top-menu__language-toggle > a').on('click', function (event) {

        event.preventDefault();

        let $this = $(this);

        if ($this.hasClass('showing')) {

            $this.next('.top-menu__language').slideUp();
            $this.removeClass('showing');

        } else {

            $this.next('.top-menu__language').slideDown();
            $this.addClass('showing');

        }

    });

    $('.vc_column_text table').wrap('<div class="table-holder"></div>');

    $('a[href="#top"]').on('click', function (event) {

        event.preventDefault();

        $('html, body').animate({scrollTop: '0px'});

    });

    $('select[name="year_filter"]').on('change', function () {

        $(this).parents('form').submit();

    });

    $('.main-menu > ul > li > a').hover(function () {
	    $('.main-menu .main-menu__row').hide();

        $('.main-menu .main-menu__row--quote').show();

    });

    $('.main-menu .main-menu__trailer').hover(function () {
	    let tab = $(this).attr('id');

        let new_tab = $('.main-menu .' + tab);
	    $('.main-menu .main-menu__trailer a').removeClass('main-menu__trailer--active');

        $('.main-menu .main-menu__row').hide();

        $('> a', $(this)).addClass('main-menu__trailer--active');

        if (new_tab.length > 0) {

            new_tab.show();

        } else {

            $('.main-menu__row--quote', $(this).parent().parent()).show();

        }

    });

    $('a[href="#readmore"]').on('click', function (event) {

        event.preventDefault();

        let $this = $(this);

        if ($this.hasClass('showing')) {

            $this.removeClass('showing');
            $this.parent().removeClass('more--showing');
            $this.children('em').text($this.attr('data-more'));
            $this.parents('.print').prev('.content').slideUp();

        } else {

            $this.addClass('showing');
            $this.parent().addClass('more--showing');
            $this.children('em').text($this.attr('data-less'));
            $this.parents('.print').prev('.content').slideDown();

        }

    });

    $body.click(function (event) {

        if ($(event.target).hasClass('search__field') || $(event.target).hasClass('search__toggle')) {

            return;
        }

        if ($(event.target).closest('.search__field').length || $(event.target)
                .closest('.search__toggle').length) {

            return;

        }

        $('.search__field.search__field--active').removeClass('search__field--active');

    });

    $('#searchform').submit(function (event) {

        if ($('#s').val() === '') {
	        event.preventDefault();

            $('.search__field.search__field--active').removeClass('search__field--active');

        }

    });

    $('.search > a').on('click', function (event) {

        event.preventDefault();

        $(this).next('.search__field').toggleClass('search__field--active');

    });

    $('.sorting select').on('change', function () {

        $(this).parents('form').submit();

    });
	Array.prototype.contains = function (v) {
	    for (let i = 0; i < this.length; i++) {
	        if (this[i] === v) {
	            return true;
            }
        }
	    return false;

    };
	Array.prototype.unique = function () {
	    let arr = [];
	    for (let i = 0; i < this.length; i++) {
	        if (!arr.contains(this[i])) {
	            arr.push(this[i]);
            }
        }
	    return arr;

    };

    $body.on('click', '.ajax-loader > a.button', function (event) {

        event.preventDefault();

        let $this = $(this);
        let $url = $this.attr('href');
        let $holder = $('#ajax-holder');

        $this.hide();
        $this.next('.loader').css('display', 'inline-block');

        $.ajax({
            url: $url,
            success: function (result) {

                let $next = $(result).filter('.next-button');

                $holder.append(result);
                $('.next-button').remove();
                $holder.after($next);

            }
        });

    });

	/**
	 * Get hash from URL
	 */
    if (window.location.hash && $body.hasClass('post-type-archive-team')) {

        let topMenuHeight = $('.top-menu').height();
        let headerHeight = $('.header').height();

        let totalHeader = topMenuHeight + headerHeight + 20;

        let hash = window.location.hash;

        setTimeout(function () {
            $('html, body').animate({scrollTop: $(hash).offset().top - totalHeader}, 1000);
        }, 1500);
    }
});

require('./filter');
